<template>
    <div>
        <topnav
            @tosearch="tosearch"
            :keywords="keyword"
            :isSearch="path"
        ></topnav>
        <div class="scontent-view">
            <div class="conwidth marginauto lall animated list-view">
                <template v-for="(item, index) in list">
                    <div class="list-item" v-if="item.type == '1'">
                        <el-tag effect="dark"> 创业服务 </el-tag>
                        {{ item.data.name }}
                    </div>
                    <div class="list-item" v-if="item.type == '2'">
                        <el-tag effect="dark"> 政策服务 </el-tag>
                        {{ item.data.name }}
                    </div>
                    <div class="list-item" v-if="item.type == '3'">
                        <el-tag effect="dark"> 活动资讯 </el-tag>
                        {{ item.data.name }}
                    </div>
                    <div class="list-item" v-if="item.type == '4'">
                        <el-tag effect="dark">场地服务 </el-tag>
                        {{ item.data.title }}
                    </div>
                    <div class="list-item" v-if="item.type == '5'">
                        <el-tag effect="dark"> 在孵化企业 </el-tag>
                        {{ item.data.shop_name }}
                    </div>
                </template>
            </div>

            <div class="" v-if="!list.length">
                <el-empty description="暂无数据"></el-empty>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            load: true,
            toptype: 6,
            pagesize: 10,
            totalnum: 100,
            currentPage: 1,
            pagerCount: 7,
            list: [],
            config: "",
            keyword: "",
            path: "/searchpage",
        };
    },
    methods: {
        todetail(e) {
            this.$router.push({ path: "/financedetail", query: { id: e } });
        },
        handleSizeChange() {},
        handleCurrentChange(currentPage) {
            this.currentPage = currentPage;
            this.getlist();
        },
        getlist() {
            // finance_list
            var data = {
                start: this.currentPage,
                page_size: this.pagesize,
                keyword: this.keyword,
            };
            this.$api.index.getquanlist(data).then((response) => {
                console.log(response);
                this.list = response.data;
                this.totalnum = response.count;
                this.load = false;
            });
        },
        tosearch(data) {
            console.log(data);
            var data = JSON.parse(data);
            this.keyword = data.keyword;
            this.list = [];
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        },
    },
    created() {
        if (this.$route.query.keyword) {
            this.keyword = this.$route.query.keyword;
            this.list = [];
            this.load = true;
            this.currentPage = 1;
            this.totalnum = 0;
            this.getlist();
        } else {
            this.getlist();
        }
        this.config = JSON.parse(localStorage.getItem("config"));
    },
};
</script>
<style scoped>
.scontent-view {
    min-height: calc(100vh - 240px - 175px);
    background-color: #eee;
}
.bggray {
    background-color: #eef1fa;
}
.topimg {
    width: 100%;
    height: 500px;
    display: block;
}
.dbtn {
    width: 200px;
    height: 45px;
    text-align: center;
    line-height: 45px;
    color: #fff;
    background-color: #0e6cec;
    border-radius: 4px;
    font-size: 16px;
}
.lall {
    min-height: 400px;
    padding-top: 45px;
}
.lone {
    width: 1280px;
    padding: 38px 20px;
    border-radius: 10px;
    margin-bottom: 20px;
}
.limg {
    height: 123px;
    width: 185px;
}
.cimg {
    width: 160px;
    height: 123px;
}
.line {
    width: 1px;
    height: 123px;
    background-color: #eeeeee;
}
.list-view {
    background-color: #fff;
}
.list-item {
    border-bottom: solid 1px #eee;
    padding: 20px;
}
</style>


// WEBPACK FOOTER //
// searchpage.vue?c616e42e